import Script from 'next/script';
import React from 'react';

import { Meta } from '@/layouts/Meta';
import { initializeStore } from '@/models/root-store';
import type { SeoData } from '@/shared/types';
import { Main } from '@/templates/Main';
import { getGeneralPageSeoData } from '@/utils/api-helpers';

type ZipPayProps = {
  seoData: SeoData;
};

const zipMerchantId = process.env.NEXT_PUBLIC_ZIP_MERCHANT_ID;

// @ts-ignore
const ZipPay: React.FC = ({ seoData }: ZipPayProps) => {
  return (
    <Main
      meta={
        <Meta
          title={seoData?.seoTitle || 'Zip Pay'}
          description={seoData?.seoDescription || 'Zip Pay'}
          canonical={`${process.env.NEXT_PUBLIC_SITE_URL}/zippay`}
        />
      }
      seoBlurb={seoData?.seoBlurb}
    >
      <Script src="https://static.zip.co/lib/js/zm-widget-js/dist/zip-widget.min.js" />
      <div className="container">
        <div
          zm-asset="landingpage"
          data-env="production"
          data-zm-merchant={zipMerchantId}
          zm-widget="inline"
          data-zm-region="au"
        ></div>
      </div>
    </Main>
  );
};

export async function getStaticProps() {
  const store = initializeStore({ ssr: true });
  const seoData: SeoData = await getGeneralPageSeoData(store, 'zippay');

  return {
    props: {
      seoData,
    },
  };
}

export default ZipPay;
